import React, { useRef, useState } from 'react'

/**
 * Bottom-of-list "+ add a task" affordance for live mode.
 *
 * Pressing Enter creates a task with title only — defaults flow from the
 * useTaskMutations.createTask helper. After successful creation the input
 * clears and stays focused for rapid task entry.
 */
export function TaskInlineCreator({ onCreate }) {
  const [draft, setDraft] = useState('')
  const inputRef = useRef(null)

  function commit() {
    const next = draft.trim()
    if (!next) return
    // Clear immediately so the user can keep typing — let the optimistic
    // update show the new row at the bottom of the list.
    setDraft('')
    Promise.resolve(onCreate({ title: next })).catch(() => {
      // The mutation hook surfaces errors via the parent's inline error
      // banner; nothing extra to do here.
    })
    inputRef.current?.focus()
  }

  function handleKeyDown(e) {
    if (e.key === 'Enter') {
      e.preventDefault()
      commit()
    } else if (e.key === 'Escape') {
      setDraft('')
    }
  }

  return (
    <div style={{ padding: '8px 4px' }}>
      <input
        ref={inputRef}
        type="text"
        value={draft}
        onChange={(e) => setDraft(e.target.value)}
        onKeyDown={handleKeyDown}
        placeholder="+ add a task"
        aria-label="Add a new task"
        maxLength={200}
        style={{
          width: '100%',
          fontSize: 13,
          border: 'none',
          borderTop: '0.5px solid #E8E9ED',
          padding: '8px 0 4px',
          outline: 'none',
          background: 'transparent',
          color: 'var(--text-primary)',
        }}
      />
    </div>
  )
}
